/**
 * Payload for EngineEvents.onSelectedEntry.
 * Fired by GroupNodeEngine when the user selects an entry.
 * @param {string} rk - active group rk
 * @param {string} nid - active node key
 * @param {string} eid - selected entry rk
 */
export default class OnSelectedEntryData {
    constructor(rk, nid, eid) {
        this.rk = rk;
        this.nid = nid;
        this.eid = eid;
    }
}
